(function () {

  // =============================================
  // Restricted product: each variant max 2 qty
  // =============================================
  var RESTRICTED_PRODUCT_ID = 7894763372630;
  var MAX = 2;
  // =============================================

  var currentProductId = null;
  var enforceButtonsTimer = null;

  /* ---- Helper: kisi bhi theme mein qty input dhundho ---- */
  function findQtyInput(scope) {
    return (scope || document).querySelector(
      'input[name="quantity"], input.quantity, input[class*="qty"], input[id*="qty"], input[id*="quantity"], input[type="number"][min]'
    );
  }

  function findPlusBtn(scope) {
    return (scope || document).querySelector(
      'button[name="plus"], [data-quantity-plus], [class*="qty-plus"], [class*="qty_plus"], [class*="quantity-plus"], [aria-label*="ncrease"], [class*="plus"], button:last-of-type.quantity__button, .quantity__button + .quantity__button'
    );
  }

  function isRestrictedProduct(productId) {
    return parseInt(productId) === RESTRICTED_PRODUCT_ID;
  }

  function getProductIdFromScope(scope) {
    var productEl = scope && scope.closest
      ? scope.closest('[data-product-id], [data-current-product]')
      : null;

    return parseInt(
      (productEl && (productEl.getAttribute('data-product-id') || productEl.getAttribute('data-current-product'))) ||
      document.body.getAttribute('data-current-product') ||
      '0'
    );
  }

  function isRestrictedScope(scope) {
    return isRestrictedProduct(getProductIdFromScope(scope));
  }

  function getKnownRestrictedVariantIds() {
    var ids = [];
    document.querySelectorAll('[data-product-id="' + RESTRICTED_PRODUCT_ID + '"], [data-current-product="' + RESTRICTED_PRODUCT_ID + '"]').forEach(function (scope) {
      var variantInput = scope.querySelector('input[name="id"], select[name="id"]');
      var variantId = variantInput ? parseInt(variantInput.value) : 0;
      if (variantId && ids.indexOf(variantId) === -1) ids.push(variantId);
    });
    return ids;
  }

  function isKnownRestrictedVariant(variantId) {
    return getKnownRestrictedVariantIds().indexOf(parseInt(variantId)) !== -1;
  }

  function parseCartBody(opts) {
    var bodyData = {};
    try {
      if (!opts || !opts.body) return bodyData;

      if (typeof opts.body === 'string') {
        try {
          bodyData = JSON.parse(opts.body);
        } catch (e) {
          new URLSearchParams(opts.body).forEach(function (v, k) { bodyData[k] = v; });
        }
      } else if (opts.body instanceof FormData || opts.body instanceof URLSearchParams) {
        opts.body.forEach(function (v, k) { bodyData[k] = v; });
      }
    } catch (e) {}

    return bodyData;
  }

  function getVariantQty(cart, variantId, skipLineIndex) {
    var qty = 0;
    cart.items.forEach(function (ci, index) {
      if (
        ci.variant_id === variantId &&
        isRestrictedProduct(ci.product_id) &&
        index !== skipLineIndex
      ) {
        qty += ci.quantity;
      }
    });
    return qty;
  }

  function normalizeAddItems(bodyData) {
    if (bodyData.items) return bodyData.items;
    if (bodyData.id) {
      return [{ id: bodyData.id, quantity: parseInt(bodyData.quantity) || 1 }];
    }
    return [];
  }

  function scheduleEnforceAddToCartButtons(delay) {
    clearTimeout(enforceButtonsTimer);
    enforceButtonsTimer = setTimeout(enforceAddToCartButtons, delay || 250);
  }

  function scheduleEnforceAfterCartUpdate() {
    [50, 250, 700].forEach(function (delay) {
      setTimeout(function () {
        enforceCartUI();
        enforceProductForms();
        enforceAddToCartButtons();
      }, delay);
    });
  }

  function scheduleEnforceAfterVariantChange() {
    unlockStaleVariantButtons();
    [50, 250, 700].forEach(function (delay) {
      setTimeout(function () {
        unlockStaleVariantButtons();
        enforceProductForms();
        enforceAddToCartButtons();
      }, delay);
    });
  }

  /* ---- Plus button lock/unlock ---- */
  function lockPlus(btn) {
    if (!btn) return;
    btn.disabled = true;
    btn.setAttribute('data-ql-locked', '1');
    btn.style.opacity = '0.35';
    btn.style.pointerEvents = 'none';
    btn.style.cursor = 'not-allowed';
  }

  function unlockPlus(btn) {
    if (!btn) return;
    btn.disabled = false;
    btn.removeAttribute('data-ql-locked');
    btn.style.opacity = '';
    btn.style.pointerEvents = '';
    btn.style.cursor = '';
  }

  function clampQtyInput(input, scope) {
    if (!input) return;

    var plusBtn = findPlusBtn(scope);
    input.setAttribute('max', MAX);
    input.setAttribute('data-max', MAX);

    var v = parseInt(input.value) || 1;
    if (v > MAX) {
      input.value = MAX;
      v = MAX;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (v >= MAX) {
      lockPlus(plusBtn);
    } else {
      unlockPlus(plusBtn);
    }
  }

  function enforceProductForm(form) {
    if (!form || !isRestrictedScope(form)) return;

    var input = findQtyInput(form);
    if (!input) return;

    clampQtyInput(input, form);

    if (input.getAttribute('data-ql-product-listener') !== '1') {
      input.setAttribute('data-ql-product-listener', '1');
      input.addEventListener('input', function () {
        clampQtyInput(input, form);
      });
      input.addEventListener('change', function () {
        clampQtyInput(input, form);
      });
    }
  }

  function enforceProductForms() {
    document.querySelectorAll('product-form, form[action*="/cart/add"], form[data-type="add-to-cart-form"], [data-product-id="' + RESTRICTED_PRODUCT_ID + '"]').forEach(function (form) {
      enforceProductForm(form);
    });
  }

  function setVariantButtonsDisabled(variantId, disabled) {
    document.querySelectorAll('form[action*="/cart/add"], form[data-type="add-to-cart-form"], product-form form').forEach(function (form) {
      var variantInput = form.querySelector('input[name="id"], select[name="id"]');
      if (!variantInput || parseInt(variantInput.value) !== parseInt(variantId)) return;

      var buttons = form.querySelectorAll('button[type="submit"], .shopify-payment-button__button');
      buttons.forEach(function (button) {
        if (disabled) {
          button.disabled = true;
          button.setAttribute('aria-disabled', 'true');
          button.setAttribute('data-ql-disabled', '1');
          button.setAttribute('data-ql-disabled-variant', variantId);
          button.style.opacity = '0.4';
          button.style.cursor = 'not-allowed';
        } else if (button.getAttribute('data-ql-disabled') === '1') {
          button.disabled = false;
          button.removeAttribute('aria-disabled');
          button.removeAttribute('data-ql-disabled');
          button.removeAttribute('data-ql-disabled-variant');
          button.style.opacity = '';
          button.style.cursor = '';
        }
      });
    });
  }

  function unlockButton(button) {
    if (!button || button.getAttribute('data-ql-disabled') !== '1') return;
    button.disabled = false;
    button.removeAttribute('aria-disabled');
    button.removeAttribute('data-ql-disabled');
    button.removeAttribute('data-ql-disabled-variant');
    button.style.opacity = '';
    button.style.cursor = '';
  }

  function unlockStaleVariantButtons() {
    document.querySelectorAll('form[action*="/cart/add"], form[data-type="add-to-cart-form"], product-form form').forEach(function (form) {
      var variantInput = form.querySelector('input[name="id"], select[name="id"]');
      var variantId = variantInput ? parseInt(variantInput.value) : 0;
      if (!variantId) return;

      form.querySelectorAll('[data-ql-disabled="1"]').forEach(function (button) {
        var disabledVariantId = parseInt(button.getAttribute('data-ql-disabled-variant'));
        if (disabledVariantId && disabledVariantId !== variantId) {
          unlockButton(button);
        }
      });
    });
  }

  /* ---- Product Page ---- */
  function initProductPage() {
    // Shopify global object se product id lo
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      currentProductId = parseInt(window.ShopifyAnalytics.meta.product.id);
    } else if (window.meta && window.meta.product) {
      currentProductId = parseInt(window.meta.product.id);
    } else {
      // Liquid se inject kiya hua id check karo
      currentProductId = parseInt(document.body.getAttribute('data-current-product') || '0');
    }

    if (!currentProductId || !isRestrictedProduct(currentProductId)) return;

    var input = findQtyInput();
    var plusBtn = findPlusBtn();

    if (!input) return;

    input.setAttribute('max', MAX);

    function checkVal() {
      var v = parseInt(input.value) || 1;
      if (v > MAX) {
        input.value = MAX;
        v = MAX;
      }
      if (v >= MAX) {
        lockPlus(plusBtn);
        // Minus ke baad re-search karo kyunki Refuel DOM replace karta hai
        setTimeout(function () {
          plusBtn = findPlusBtn();
          lockPlus(plusBtn);
        }, 80);
      } else {
        unlockPlus(plusBtn);
      }
    }

    input.addEventListener('input', checkVal);
    input.addEventListener('change', checkVal);

    // Plus/minus buttons pe click listener
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('button, span, a');
      if (!btn) return;
      var lbl = (btn.getAttribute('aria-label') || btn.textContent || btn.className || '').toLowerCase();
      var isPlus = lbl.includes('increase') || lbl.includes('plus') || btn.textContent.trim() === '+';
      var isMinus = lbl.includes('decrease') || lbl.includes('minus') || btn.textContent.trim() === '-' || btn.textContent.trim() === '—';
      if (isPlus || isMinus) {
        setTimeout(function () {
          plusBtn = findPlusBtn();
          checkVal();
        }, 80);
      }
    });

    checkVal();
  }

  /* ---- Cart mein add hone se rokna (fetch intercept) ---- */
  var _fetch = window.fetch;
  window.fetch = function (url, opts) {
    var urlString = typeof url === 'string' ? url : (url && url.url) || '';

    if (urlString.includes('/cart/add')) {
      return _fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var bodyData = parseCartBody(opts);
          var items = normalizeAddItems(bodyData);
          var variantsToDisable = [];

          for (var i = 0; i < items.length; i++) {
            var variantId = parseInt(items[i].id);
            var addQty = parseInt(items[i].quantity) || 1;

            var existingQty = getVariantQty(cart, variantId);
            var restrictedVariant = existingQty > 0 || isKnownRestrictedVariant(variantId);

            if (isRestrictedProduct(currentProductId) || restrictedVariant) {
              if (existingQty + addQty > MAX) {
                showCartError();
                return Promise.reject(new Error('MAX_QTY_REACHED'));
              }
              if (existingQty + addQty >= MAX) {
                variantsToDisable.push(variantId);
              }
            }
          }

          return _fetch(url, opts).then(function (response) {
            variantsToDisable.forEach(function (variantId) {
              setVariantButtonsDisabled(variantId, true);
            });
            // Cart update hone ke baad buttons re-check karo
            scheduleEnforceAfterCartUpdate();
            return response;
          });
        });
    }

    if (urlString.includes('/cart/change')) {
      var changeBodyData = parseCartBody(opts);
      var changeQuantity = parseInt(changeBodyData.quantity);

      if (!changeQuantity || changeQuantity <= 0) {
        return _fetch(url, opts).then(function (response) {
          scheduleEnforceAfterCartUpdate();
          return response;
        });
      }

      return _fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var bodyData = changeBodyData;
          var line = parseInt(bodyData.line);
          var quantity = changeQuantity;
          var item = line ? cart.items[line - 1] : null;

          if (item && isRestrictedProduct(item.product_id) && quantity > 0) {
            var otherQty = getVariantQty(cart, item.variant_id, line - 1);
            if (otherQty + quantity > MAX) {
              showCartError();
              enforceCartUI();
              return Promise.reject(new Error('MAX_QTY_REACHED'));
            }
          }

      return _fetch(url, opts).then(function (response) {
        setTimeout(function () {
          enforceCartUI();
          scheduleEnforceAfterCartUpdate();
        }, 500);
        return response;
      });
        });
    }

    return _fetch(url, opts);
  };

  /* ---- Cart Drawer / Cart Page quantity limit ---- */
  function enforceCartUI() {
    // Cart items dhundo jo restricted hain
    var allQtyInputs = document.querySelectorAll(
      'input[name="updates[]"], input[data-quantity-input], .cart-item input[type="number"], [class*="cart"] input[type="number"]'
    );

    allQtyInputs.forEach(function (input) {
      // Parent mein product id dhundo
      var row = input.closest('[data-product-id], [data-id], .cart-item, tr');
      if (!row) return;

      var pid = parseInt(
        row.getAttribute('data-product-id') ||
        row.getAttribute('data-id') ||
        row.querySelector('[data-product-id]')?.getAttribute('data-product-id') || '0'
      );

      if (!isRestrictedProduct(pid)) return;

      input.setAttribute('max', MAX);

      var plusBtn = row.querySelector('[data-quantity-plus], button[name="plus"], [class*="plus"], [aria-label*="ncrease"]');
      if (parseInt(input.value) >= MAX) {
        lockPlus(plusBtn);
      } else {
        unlockPlus(plusBtn);
      }

      if (input.getAttribute('data-ql-listener') !== '1') {
        input.setAttribute('data-ql-listener', '1');
        input.addEventListener('change', function () {
          if (parseInt(this.value) > MAX) {
            this.value = MAX;
            this.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }
    });
  }

  /* ---- Add to Cart buttons disable/enable everywhere ---- */
  function enforceAddToCartButtons() {
    var allForms = document.querySelectorAll('form[action*="/cart/add"], form[data-type="add-to-cart-form"], product-form form');
    if (!allForms.length) return;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {

        // Pehle check karo: kaunse restricted variants cart mein MAX qty pe hain
        var fulfilledVariants = [];

        cart.items.forEach(function (item) {
          if (isRestrictedProduct(item.product_id) && getVariantQty(cart, item.variant_id) >= MAX) {
            fulfilledVariants.push(item.variant_id);
          }
        });

        allForms.forEach(function (form) {
          var submitBtn = form.querySelector('button[type="submit"]');
          if (!submitBtn) return;
          var checkoutBtn = form.querySelector('.shopify-payment-button__button');

          // Is form ka variant/product ID nikalo
          var variantInput = form.querySelector('input[name="id"], select[name="id"]');
          if (!variantInput) return;

          var variantId = parseInt(variantInput.value);

          // Check: kya yeh variant fulfilled hai?
          var isFulfilled = fulfilledVariants.indexOf(variantId) !== -1;

          if (isFulfilled) {
            submitBtn.disabled = true;
            submitBtn.setAttribute('aria-disabled', 'true');
            submitBtn.setAttribute('data-ql-disabled', '1');
            submitBtn.setAttribute('data-ql-disabled-variant', variantId);
            submitBtn.style.opacity = '0.4';
            submitBtn.style.cursor = 'not-allowed';
            // Original text save karo aur replace karo
            if (!submitBtn.getAttribute('data-ql-orig-text')) {
              submitBtn.setAttribute('data-ql-orig-text', submitBtn.innerHTML);
            }
            submitBtn.innerHTML = submitBtn.getAttribute('data-ql-orig-text'); // text wahi rakho
            if (checkoutBtn) {
              checkoutBtn.disabled = true;
              checkoutBtn.setAttribute('aria-disabled', 'true');
              checkoutBtn.setAttribute('data-ql-disabled', '1');
              checkoutBtn.setAttribute('data-ql-disabled-variant', variantId);
              checkoutBtn.style.opacity = '0.4';
              checkoutBtn.style.cursor = 'not-allowed';
            }
          } else {
            // Agar pehle disable kiya tha to re-enable karo
            if (submitBtn.getAttribute('data-ql-disabled') === '1') {
              unlockButton(submitBtn);
            }
            if (checkoutBtn && checkoutBtn.getAttribute('data-ql-disabled') === '1') {
              unlockButton(checkoutBtn);
            }
          }
        });
      })
      .catch(function () {});
  }

  /* ---- Error message ---- */
  function showCartError() {
    var existing = document.getElementById('ql-error');
    if (existing) { existing.remove(); }

    var msg = document.createElement('div');
    msg.id = 'ql-error';
    msg.style.cssText = [
      'position:fixed', 'bottom:24px', 'left:50%', 'transform:translateX(-50%)',
      'background:#dc2626', 'color:#fff', 'padding:12px 22px', 'border-radius:8px',
      'font-size:14px', 'font-weight:500', 'z-index:99999',
      'box-shadow:0 4px 12px rgba(0,0,0,0.25)', 'text-align:center',
      'max-width:320px', 'line-height:1.5'
    ].join(';');
    msg.textContent = 'A maximum quantity of 2 can be added for this variant.';
    document.body.appendChild(msg);
    setTimeout(function () { msg.remove(); }, 3500);
  }

  /* ---- MutationObserver — cart drawer open hone par bhi kaam kare ---- */
  var observer = new MutationObserver(function (mutations) {
    var hasNewNodes = false;
    mutations.forEach(function (m) {
      if (m.addedNodes.length > 0) hasNewNodes = true;
    });
    enforceProductForms();
    enforceCartUI();
    if (hasNewNodes) scheduleEnforceAddToCartButtons(350);
  });

  /* ---- Init ---- */
  function init() {
    // Build-a-box page pe script kaam na kare
    if (document.body.classList.contains('template-product-build-a-box')) return;
    
    initProductPage();
    enforceProductForms();
    enforceCartUI();
    scheduleEnforceAddToCartButtons(100);
    document.addEventListener('change', function (event) {
      if (event.target && event.target.matches('input[name="id"], select[name="id"]')) {
        scheduleEnforceAfterVariantChange();
      }
    });
    document.addEventListener('click', function (event) {
      var btn = event.target.closest('button, span, a');
      if (!btn) return;

      var form = btn.closest('product-form, form[action*="/cart/add"], form[data-type="add-to-cart-form"], [data-product-id]');
      if (!form || !isRestrictedScope(form)) return;

      enforceProductForm(form);

      var lbl = (btn.getAttribute('aria-label') || btn.textContent || btn.className || '').toLowerCase();
      var isPlus = lbl.includes('increase') || lbl.includes('plus') || btn.textContent.trim() === '+';
      var isMinus = lbl.includes('decrease') || lbl.includes('minus') || btn.textContent.trim() === '-' || btn.textContent.trim() === 'â€”';
      if (isPlus || isMinus) {
        setTimeout(function () {
          enforceProductForm(form);
        }, 80);
      }
    }, true);
    document.addEventListener('submit', function (event) {
      var form = event.target.closest('form[action*="/cart/add"], form[data-type="add-to-cart-form"]');
      if (form && isRestrictedScope(form)) enforceProductForm(form);
    }, true);
    if (
      typeof subscribe === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined' &&
      PUB_SUB_EVENTS.cartUpdate
    ) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleEnforceAfterCartUpdate);
      if (PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, scheduleEnforceAfterVariantChange);
      }
    }
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
